import React from 'react';
import styled from 'styled-components';
import { DeviceType } from '../../../shared/enum/EnumRepository';
import { useDeviceStore } from '../../../shared/store/deviceStore';
import { MemberFilterData } from '../../../shared/dto/EntityRepository';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { getAlertMessage } from '../../../shared/constants/alertMessages';
import { AlertPosition, AlertType } from '../../../shared/enum/EnumRepository';

interface FilterStationMemberLastLoginAtProps {
  currentFilter: MemberFilterData;
  setCurrentFilter: (filter: MemberFilterData) => void;
}

const FilterStationMemberLastLoginAt: React.FC<FilterStationMemberLastLoginAtProps> = ({
  currentFilter,
  setCurrentFilter,
}) => {
  const { deviceType } = useDeviceStore();
  const { enqueueAlert } = useStandardAlertStore();
  const { min, max } = currentFilter.lastLoginAt;

  const handleMinChange = (value: string) => {
    const minValue = value === '' ? null : value;
    if (
      minValue !== null &&
      max !== null &&
      minValue > max
    ) {
      enqueueAlert({
        type: AlertType.ALERT,
        position: AlertPosition.TOP,
        content: getAlertMessage('START_YEAR_GREATER_THAN_END'),
      });
      return;
    }
    setCurrentFilter({
      ...currentFilter,
      lastLoginAt: { ...currentFilter.lastLoginAt, min: minValue },
    });
  };

  const handleMaxChange = (value: string) => {
    const maxValue = value === '' ? null : value;
    if (
      maxValue !== null &&
      min !== null &&
      maxValue < min
    ) {
      enqueueAlert({
        type: AlertType.ALERT,
        position: AlertPosition.TOP,
        content: getAlertMessage('END_YEAR_SMALLER_THAN_START'),
      });
      return;
    }
    setCurrentFilter({
      ...currentFilter,
      lastLoginAt: { ...currentFilter.lastLoginAt, max: maxValue },
    });
  };

  return (
    <LastLoginFilterComp>
      <LastLoginSubTitle $isMobile={deviceType === DeviceType.MOBILE}>
        Last login
      </LastLoginSubTitle>
      <DateSection>
        <DateInput
          type="date"
          value={min ?? ''}
          onChange={(e) => handleMinChange(e.target.value)}
          max={max ?? undefined}
        />
        <Dash>-</Dash>
        <DateInput
          type="date"
          value={max ?? ''}
          onChange={(e) => handleMaxChange(e.target.value)}
          min={min ?? undefined}
        />
      </DateSection>
    </LastLoginFilterComp>
  );
};

export default FilterStationMemberLastLoginAt;

const LastLoginSubTitle = styled.div<{ $isMobile: boolean }>`
  margin-bottom: ${({ $isMobile }) => ($isMobile ? '2vh' : '1.2vh')};
  ${({ theme, $isMobile }) =>
    $isMobile ? theme.typography.Body_02_1 : theme.typography.Body_03_1};
`;

const LastLoginFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`;

const DateSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;

const Dash = styled.span`
  flex-shrink: 0;
`;

const DateInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  border-radius: 0;
  background: transparent;
  outline: none;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};

  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
    opacity: 0.6;
  }
`;
